import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { Constants } from '../constants';
import { FaMapMarkerAlt } from "react-icons/fa";
import { Box, Button, CardActionArea, Stack } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import { useNavigate } from 'react-router-dom';
import CurrencyRupeeIcon from '@mui/icons-material/CurrencyRupee';
import useResponsive from '../utils/Responsive';
import { MovingText } from '../utils/MovingText';

const CourseCard = ({ item }) => {
    const navigate = useNavigate()
    const isSmallScreen = useResponsive("sm")
    const { title, price, location_name, is_featured, id ,cover_image } = item
    return (
        <Card sx={{ boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)", bgcolor: "primary.light", borderRadius: "40px", width: "100%", my: 1 }}>
            <CardActionArea onClick={() => navigate(`/CoursesDetail/${id}`)} sx={{ width: "100%", height: "100%", display: "flex", flexDirection: "column", justifyContent: "start" }} >
                <CardContent
                    sx={{
                        backgroundImage: `url(${`https://stage.myskool.club/collab/assets/images/event/cover/${cover_image}`})`,
                        backgroundSize: "cover",
                        backgroundPosition: "center",
                        height: "250px",
                        width: "100%",
                        borderTopRightRadius: "40px",
                        borderTopLeftRadius: "40px",
                        py: { xs: 2, lg: 3 },
                        px: { xs: 2, lg: 5 }
                    }}
                >
                    {is_featured === 1 && (
                        <Box
                            sx={{
                                clipPath: "polygon(29% 0, 57% 0, 56% 100%, 42% 84%, 28% 100%)",
                                backgroundColor: "red.main",
                                width: "120px",
                                height: "120px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                position: "absolute",
                                top: "0px",
                                right: "-20px",
                                pr: 3
                            }}
                        >
                            <Typography
                                variant="body2"
                                sx={{
                                    transform: "rotate(-90deg)",
                                    color: "#fff",
                                    fontWeight: "bold",
                                }}
                            >
                                Featured
                            </Typography>
                        </Box>
                    )
                    }
                </CardContent>
                <CardContent sx={{ py: 3, px: 5, width: { xs: "95%", lg: "80%" } }} >
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2, width: "100%" }}>
                        <Box width={"85%"}>
                            <MovingText text={title} />
                            <Typography variant="body2" color='grey.100' mt={0.5} sx={{ display: "flex", alignItems: "center" }}>
                                <FaMapMarkerAlt style={{ color: "#DC143C", fontSize: "16px", margin: "0 5px 0 0" }} />
                                {location_name}
                            </Typography>
                        </Box>
                        <Box
                            sx={{
                                backgroundColor: "red.main",
                                display: "flex",
                                borderRadius: "12px",
                                p: "2px 10px",
                                gap: 0.5,
                                alignItems: 'center',
                                width: "10%"

                            }}
                        >
                            <Typography variant='body2' color='primary.main'>4</Typography>
                            <StarIcon sx={{ color: "primary.main", fontSize: "14px" }} />
                        </Box>
                    </Box>
                    <Stack width="100%" justifyContent="center" alignItems="center">
                        <Button
                            variant="outlined"
                            style={{ width: isSmallScreen ? "100%" : "80%" }}
                            startIcon={<CurrencyRupeeIcon sx={{ fontSize: "16px", color: "red.main", ml: 2 }} />}
                        >
                            {price}
                        </Button>
                    </Stack>
                </CardContent>
            </CardActionArea>
        </Card>
    )
}

export default CourseCard